import {Component, forwardRef, Inject, Input, OnInit} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {Location} from '@angular/common';
import {Router} from '@angular/router';
import {MenuItem} from 'primeng/primeng';
import {AppComponent} from './app.component';
import {ObservableLotacao} from './util/observable-util';
import {MenuEpc} from './entity/menu.model';

@Component({
  selector: 'app-menu',
  template: `
      <ul app-submenu [item]="model" root="true" class="ultima-menu ultima-main-menu clearfix" [reset]="reset"
          visible="true"></ul>
  `
})
export class AppMenuComponent implements OnInit {

  @Input() reset: boolean;

  model: any[] = [];


  constructor(@Inject(forwardRef(() => AppComponent)) public app: AppComponent, private lotacaoService: ObservableLotacao) {
  }

  ngOnInit() {
    if (localStorage.getItem("token") != null)
      this.lotacaoService.getLotacao.subscribe(permissions => {
        if (permissions.text.isLoaded)
          this.model = new MenuEpc().presetMenu.filter(item => this.filterMenu(item, permissions.text));
      });
  }

  filterMenu(item: any, permissions: any) {
    if (item['items'] != null) {
      var children = item['items'].filter(childItem => this.filterMenu(childItem, permissions));
      if (children.length > 0) {
        item['items'] = children;
        return true;
      } else {
        return false;
      }
    } else if (item['routerLink'] == null) {
      return false;
    } else if (item['routerLink'][0] == '/') {
      return true;
    } else{
        var finalPerm = (item['routerLink'][0].split("/")[1] + "_MENU").replace(/[^0-9A-Za-z]/g, '_').toUpperCase();
      finalPerm = finalPerm.search("-") == -1 ? finalPerm : finalPerm.replace('-', '_');
      var temPerfil = permissions.perfilDTO.find(perfil => perfil.perfilFuncionalidadeAcaoDTO.find(perm => perm == finalPerm || perm == "ADMINISTRADOR"));
    if (finalPerm != null && finalPerm == 'HOMOLOGACAO_CAPACITADORA_MENU' && temPerfil && temPerfil.nome == 'Capacitadora') {
      return false;
    } else {
      return temPerfil == null ? false : true;
    }
  }
}

changeTheme(theme)
{
  let themeLink: HTMLLinkElement = <HTMLLinkElement>document.getElementById('theme-css');
  let layoutLink: HTMLLinkElement = <HTMLLinkElement>document.getElementById('layout-css');

  themeLink.href = 'assets/theme/theme-' + theme + '.css';
  layoutLink.href = 'assets/layout/css/layout-' + theme + '.css';
}
}

@Component({
  selector: '[app-submenu]',
  template: `
      <ng-template ngFor let-child let-i="index" [ngForOf]="(root ? item : item.items)">
          <li [ngClass]="{'active-menuitem': isActive(i)}" [class]="child.badgeStyleClass"
              *ngIf="child.visible === false ? false : true">
              <a [href]="child.url||'#'" (click)="itemClick($event,child,i)" class="ripplelink"
                 *ngIf="!child.routerLink" [attr.tabindex]="!visible ? '-1' : null" [attr.target]="child.target">
                  <i class="material-icons">{{ child.icon }}</i>
                  <span>{{ child.label }}</span>
                  <span class="menuitem-badge" *ngIf="child.badge">{{ child.badge }}</span>
                  <i class="material-icons" *ngIf="child.items">keyboard_arrow_down</i>
              </a>

              <a (click)="itemClick($event,child,i)" class="ripplelink" *ngIf="child.routerLink"
                 [routerLink]="child.routerLink" routerLinkActive="active-menuitem-routerlink"
                 [routerLinkActiveOptions]="{exact: true}" [attr.tabindex]="!visible ? '-1' : null"
                 [attr.target]="child.target">
                  <i class="material-icons">{{ child.icon }}</i>
                  <span>{{ child.label }}</span>
                  <span class="menuitem-badge" *ngIf="child.badge">{{ child.badge }}</span>
                  <i class="material-icons" *ngIf="child.items">keyboard_arrow_down</i>
              </a>
              <ul app-submenu [item]="child" *ngIf="child.items" [@children]="isActive(i) ? 'visible' : 'hidden'"
                  [visible]="isActive(i)" [reset]="reset"></ul>
          </li>
      </ng-template>
  `,
  animations: [
    trigger('children', [
      state('hidden', style({
        height: '0px'
      })),
      state('visible', style({
        height: '*'
      })),
      transition('visible => hidden', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
      transition('hidden => visible', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
    ])
  ]
})
export class AppSubMenu {

  @Input() item: MenuItem;

  @Input() root: boolean;

  @Input() visible: boolean;

  _reset: boolean;

  activeIndex: number;

  constructor(@Inject(forwardRef(() => AppComponent)) public app: AppComponent, public router: Router, public location: Location) {
  }

  itemClick(event: Event, item: MenuItem, index: number) {
    //avoid processing disabled items
    if (item.disabled) {
      event.preventDefault();
      return true;
    }

    //activate current item and deactivate active sibling if any
    this.activeIndex = (this.activeIndex === index) ? null : index;

    //execute command
    if (item.command) {
      item.command({originalEvent: event, item: item});
    }

    //prevent hash change
    if (item.items || (!item.url && !item.routerLink)) {
      event.preventDefault();
    }

    //hide menu
    if (!item.items) {
      if (this.app.isHorizontal())
        this.app.resetMenu = true;
      else
        this.app.resetMenu = false;

      this.app.overlayMenuActive = false;
      this.app.staticMenuMobileActive = false;
    }
  }

  isActive(index: number): boolean {
    return this.activeIndex === index;
  }

  @Input() get reset(): boolean {
    return this._reset;
  }

  set reset(val: boolean) {
    this._reset = val;

    if (this._reset && this.app.isHorizontal()) {
      this.activeIndex = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.menu.component.ts